import React, {useEffect, useState} from 'react'
// import Logo from '../assets/svgIcon/360logofooter';
import logoUrl from '../assets/images/starlogo.png';
import zhanhuoLogoUrl from '../assets/images/zhanhuoLogo.png';
import mvzlLogoUrl from '../assets/images/mnzlLogo.png';
import tmmnzlLogoUrl from '../assets/images/tmmnzlLogo.png';
import dsjyLogoUrl from '../assets/images/dsjyLogo.png';
import bbtsaxcLogoUrl from '../assets/images/bbtsaxcLogo.png';
import skdzzLogoUrl from '../assets/images/skdzzLogo.png';
import wujinLogoUrl from '../assets/images/wujinlogo.png';
const maps = new Map([
    ['/myquiz/quizdetail', '/quizdetail'],
    ['/onlineconsultation', '/gamechoose'],
    ['/onlineconsultationim', '/'],
    ['/accountproblems', '/quikform'],
    ['/accountproblems/accountdetail', '/gamechoose'],
    ['/accountproblems/accountcontent', '/nofkeycontent']
])

const switchQuery = (query, before, after) => {
    return query.replace(before, after);
}

const switchToPhone = () => {
    let location = window.location;
    let name = maps.get(location.pathname);
    let query = location.search;
    if (name) {
        if (name === '/quikform') {
            query = switchQuery(query, 'accountid', 'id')
        }
        if (name === '/nofkeycontent') {
            query = switchQuery(query, 'fid', 'id')
        }
        window.location.href = `//h5.gm.game.360.cn${name}${query}`;
        return;
    }
    window.location.href = `//h5.gm.game.360.cn${location.pathname}${query}`
}

if(/Android|webOS|iPhone|iPod|iPad/i.test(navigator.userAgent)) {
    switchToPhone();
}
const Footer = (props) => {
    const {
        mark
    } = props;

    const [logo,setLogo] = useState();
    useEffect(()=>{
        if(mark){
            if(mark === 'starworld-70b82b05626acebf7608c85834ad654a'){
                setLogo(zhanhuoLogoUrl);
                return;
            }
            if(mark === 'starworld-4d869fd5b900b6fc1cb0c5bc8f6873a4'){
                setLogo(mvzlLogoUrl);
                return;
            }

            if(mark === 'starworld-f08eb42647e2aa91a5c729e547ba49b3'){
                setLogo(dsjyLogoUrl);
                return;
            }
            if(mark === 'starworld-2af8982d2789a9b475753749b9ccf6b0'){
                setLogo(tmmnzlLogoUrl)
                return;
            }
            if(mark === 'starworld-f9a290e3af46f3e1e68ec294d8335248'){
                setLogo(bbtsaxcLogoUrl);
                return;
            }
            if(mark === 'starworld-3332f098f975c5706fcece81fdfcfcaf'){
                setLogo(skdzzLogoUrl);
                return;
            }
            if(mark === 'wan_dudai-wj'){
                setLogo(wujinLogoUrl);
                return;
            }
            setLogo(logoUrl);
        }
    },[mark]);

    return (
      <section>
         <style jsx>{`
             .footer {
                width: 100%;
                height: 164px;
                background: white;
                display: flex;
                flex-shrink: 0;
                font-size: 14px;
                color:#999999;
                min-width: 1200px;
            }
            .footer-content {
                position: relative;
                padding-top:60px;
                min-width: 1200px;
                margin: 0 auto;
            }
            .logoPic{
                width:107px;
                // height:30px;
                height:107px;
            }
            .logo {
                position: absolute;
                left: 4px;
                top: 50%;
                transform: translateY(-50%);
            }
            .footer-txt a, .footer-txt button {
                white-space: nowrap !important;
                // cursor: pointer;
            }
            .footer-txt {
                width: 920px;
                position: absolute;
                right: 69px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 12px;
                line-height: 22px;
                color:#999999;
            }
            .footer-txt p {
                margin: 0;
                line-height: 22px;
                white-space: nowrap;
            }
            .footer-txt a, .footer-txt span {
                color:#999999;
            }
            .footer-txt a:hover {
                color: #D0021B;
            }
            .top {
                width: 887px;
                margin-bottom:2px;
                margin-top:20px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
            .top a{
                 color:#999999;
            }
            .center {
                width: 887px;
                margin-bottom:2px;
                display: flex;
                flex-direction: row;
     
            }
            .bottom {
                width:387px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                flex-wrap:nowrap;
            }
            .switchToPhone {
                color: #999090;
            }
         `}
         </style>
         <section className="footer">
            <div className="footer-content">
                <div className="logo">
                    {logo && <img className="logoPic" src={logo} style={mark && (mark === 'starworld-f08eb42647e2aa91a5c729e547ba49b3' || mark === 'starworld-2af8982d2789a9b475753749b9ccf6b0')?{width:'auto',height:'48px'}:( mark && (mark === 'starworld-f9a290e3af46f3e1e68ec294d8335248' ||  mark === 'starworld-3332f098f975c5706fcece81fdfcfcaf')?{width:'auto',height:'68px'}:{})}  fill="white" alt=" "/>}
                </div>
                <div className="footer-txt">
                    <p>
                        <span className="span-footer-0" style={{paddingLeft: 0}}>
                            <a target="_blank" href="https://dd-cms.wan.youxi.com/qy-yyzz.html" rel="noopener noreferrer">趣游时代(北京)科技有限公司</a>
                            <a target="_blank" href="https://p4.ssl.qhimg.com/d/inn/f2ade81678f2/youxi.png" style={{paddingLeft: 0}} rel="noopener noreferrer"> | 京B2-20170671</a>
                            <a target="_blank" href="https://beian.miit.gov.cn/" style={{paddingLeft: 0}} rel="noopener noreferrer"> | 京ICP备11029981号-10</a>
                            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502035516" rel="noopener noreferrer"> | 京公网安备11010502035516号</a>
                        </span>
                    </p>
                    <p>
                        <span className="span-footer-1" style={{paddingLeft: 0}}>
                            <a target="_blank" href="https://dd-cms.wan.youxi.com/xh-yyzz.html" rel="noopener noreferrer">北京世界星辉科技有限责任公司</a>
                            <a target="_blank" href="https://w01.ddgame.yx-s.com/web-game-cdn-source/d9fc7e347b894d6e83103a4052e31acf.png" style={{paddingLeft: 0}} rel="noopener noreferrer"> | 京ICP证140771号</a>
                            <span style={{paddingLeft: 0}}> | 2016SR348327</span>
                            <span style={{paddingLeft: 0}}> | 新广出审[2017]5521号</span>
                            <span style={{paddingLeft: 0}}> | ISBN 978-7-7979-8785-1</span>
                        </span>
                    </p>
                    <p>
                        <span className="span-footer-2" style={{paddingLeft: 0}}>
                            <a target="_blank" href="https://dd-cms.wan.youxi.com/360sz-img.html" rel="noopener noreferrer">北京三六零数智科技有限公司</a>
                            <a target="_blank" href="https://dd-cms.wan.youxi.com/360sz-icp.html" style={{paddingLeft: 0}} rel="noopener noreferrer"> | 京B2-20210074</a>
                        </span>
                    </p>
                    <p>Copyright©2005-2026 360游戏 All Rights Reserved</p>
                    <p>健康游戏忠告:</p>
                    <p>抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。</p>
                </div>
            </div>
        </section>
      </section>
    )
}

export default Footer




